const ADDRESSCLOUD_TILE_ENV = process.env.REACT_APP_ADDRESSCLOUD_TILE_ENV || '';
const OS_API_KEY = process.env.REACT_APP_OS_API_KEY || '';

export {
  ADDRESSCLOUD_TILE_ENV,
  OS_API_KEY,
};
